
const Header = () => {
  return (
    <header className="App-header">
           <h3> Calculator app created with React</h3>
    </header>
  );
};

export default Header;
